import SolutionPageTemplate from "./SolutionPageTemplate";

const AtendimentoOnlineHomeOffice = () => (
  <SolutionPageTemplate
    title="Bem-Estar no Home Office"
    intro={[
      "A Sodalita oferece soluções de bem-estar para equipes remotas e híbridas, garantindo que os colaboradores tenham acesso ao cuidado com a saúde física e emocional independentemente de sua localização.",
      "Os atendimentos são desenvolvidos para apoiar o equilíbrio, a produtividade e a qualidade de vida no trabalho remoto.",
    ]}
    benefits={[
      "Suporte ao bem-estar emocional",
      "Aumento da concentração e da produtividade",
      "Atendimento individualizado e acessível",
      "Redução do estresse e do desgaste emocional",
      "Flexibilidade para equipes híbridas e remotas",
    ]}
    sectionId="atendimento-online-home-office"
    modifier="solution-page--online"
  />
);

export default AtendimentoOnlineHomeOffice;
